module.exports = __webpack_public_path__ + "img/2_228.8e9ceffc.png";